// Function to resize image if it exceeds 3000x1600
export const resizeImage = (img, maxWidth, maxHeight) => {
  const canvas = document.createElement("canvas");
  let width = img.width;
  let height = img.height;

  if (width > maxWidth || height > maxHeight) {
    const scale = Math.min(maxWidth / width, maxHeight / height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }

  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);

  return canvas.toDataURL("image/jpeg", 0.6); // Convert to a compressed image
};
